"use client";
import { jsxs as d, jsx as t } from "react/jsx-runtime";
import { skeleton as o } from "../../ui/recipes/skeleton.js";
import { dataAttr as a, cn as r } from "../../utils.js";
const i = () => Array.from({ length: 3 }).map((n, l) => {
  const e = l % 2 === 0;
  return /* @__PURE__ */ d(
    "div",
    {
      className: r(
        "flex items-center flex-row-reverse",
        "data-[even]:flex-row",
        "[--end-color:theme(colors.white-alpha.100)]",
        "dark:[--start-color:theme(colors.gray.300)]",
        "dark:[--end-color:theme(colors.white-alpha.300)]"
      ),
      "data-even": a(e),
      children: [
        /* @__PURE__ */ t(
          "div",
          {
            "data-even": a(e),
            className: r(
              o(),
              "h-12 w-12 rounded-full",
              "data-[even]:mr-4 ml-4 data-[even]:ml-0"
            )
          }
        ),
        /* @__PURE__ */ d(
          "div",
          {
            "data-even": a(e),
            className: "flex flex-col gap-2 items-end data-[even]:items-start",
            children: [
              /* @__PURE__ */ t("div", { "data-even": a(e), className: r(o(), "h-4 rounded-lg w-60") }),
              /* @__PURE__ */ t("div", { "data-even": a(e), className: r(o(), "h-4 rounded-lg w-56") })
            ]
          }
        )
      ]
    },
    l
  );
});
export {
  i as ConversationLoading
};
